import type { Op } from 'quill/core';
import { Delta } from 'quill/core';

/**
 * The first line of the changeset is the title,
 * so we extract the content by omitting the first line.
 */
const extractContent = (content: Op[]) => {
  let rest = new Delta(content);
  rest.eachLine((line) => {
    rest = rest.slice(line.length() + 1);
    return false;
  });
  return rest;
};

export default extractContent;
